import { withFormik } from 'formik';
import { object, boolean, ref, string } from 'yup';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { selectGeoLocation } from '#src/store/session/selectors';

import { handleSubmit } from './helpers';

export const withCheckoutForm = compose(
  connect((state) => ({ geo: selectGeoLocation(state) })),
  withFormik({
    displayName: 'CheckoutWithForm',
    mapPropsToValues: ({ requiresRegistration, user: { email } = {} }) => {
      return {
        storeInVault: true,
        email,
        password: '',
        passwordConfirmation: '',
        requiresRegistration,
      };
    },
    validationSchema: object().shape({
      email: string().when('requiresRegistration', {
        is: true,
        then: string().email('Invalid email').required('Email is required'),
        otherwise: null,
      }),
      password: string().when('requiresRegistration', {
        is: true,
        then: string().min(8).required(),
        otherwise: null,
      }),
      passwordConfirmation: string().when('requiresRegistration', {
        is: true,
        then: string()
          .oneOf([ref('password'), null], 'Passwords do not match')
          .required(),
        otherwise: null,
      }),
      storeInVault: boolean().required(),
    }),
    handleSubmit,
    validateOnMount: true,
  })
);
